import { useState } from 'react';

function useBell() {
  const [audio, setAudio] = useState(null);

  const loadAudio = () => {
    if (!audio) {
      const newAudio = new Audio('/sounds/bell.mp3');
      setAudio(newAudio);
    }
  };

  const playBellSound = () => {
    loadAudio(); // Load the audio if not already loaded
    if (audio) {
      audio.play().catch((error) => {
        // Handle any errors that occur during playback (e.g., unsupported format)
        console.error('Error playing bell sound:', error);
      });
    }
  };

  return { playBellSound };
}

export default useBell;
